import { render, staticRenderFns } from "./show-button.vue?vue&type=template&id=1119d9e8&scoped=true"
import script from "./show-button.vue?vue&type=script&lang=js"
export * from "./show-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1119d9e8",
  null
  
)

export default component.exports